"use client";

import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import ProfessionalCard from "@/components/common/ProfessionalCard";
import "swiper/css";
import "swiper/css/pagination";

function TestimonialsClient({ testimonials }) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Function to update state based on window width
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkIfMobile();
    window.addEventListener("resize", checkIfMobile);
    return () => {
      window.removeEventListener("resize", checkIfMobile);
    };
  }, []);

  useEffect(() => {
    // This effect runs only on the client side
    setIsMobile(window.innerWidth < 768);
  }, []);
  return (
    <>
      {/* Mobile Swiper */}
      {isMobile ? (
        <div className="w-full flex-grow flex items-center mt-15 md:mt-0">
          <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={20}
            slidesPerView={1}
            pagination={{
              clickable: true,
              dynamicBullets: true
            }}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false
            }}
            className="w-full"
            style={{
              "--swiper-pagination-color": "#7BB392",
              "--swiper-pagination-bullet-inactive-color": "#7BB392",
              "--swiper-pagination-bullet-inactive-opacity": "0.5",
              "--swiper-pagination-bullet-inactive-scale": "0.8"
            }}
          >
            {testimonials.map((card, index) => (
              <SwiperSlide
                key={index}
                className="pb-12 py-2 flex items-stretch whitespace-pre-line"
              >
                <ProfessionalCard
                  position={card.position}
                  title={card.title}
                  description={card.description}
                  image={card.image}
                  className="h-full flex flex-col"
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-6 lg:gap-6 py-4 md:p-0 lg:pb-10 px-4 lg:px-[8vw] items-stretch">
          {testimonials.map((card, index) => (
            <div key={index} className="flex gap-4 md:gap-6 lg:gap-6 xl:gap-7 2xl:gap-8">
              <ProfessionalCard
                position={card.position}
                title={card.title}
                description={card.description}
                image={card.image}
              />
            </div>
          ))}
        </div>
      )}
    </>
  );
}

export default TestimonialsClient;
